import cn from 'classnames';
import { FontIcon, ImageContainer, Text } from '@intigral/shared';
import styles from './channel-card.module.sass';

export interface IChannelCard {
    isSelected: boolean;
    index: number;
    onChannelSelect: () => void;
    logoSrc: string;
    title: string;
    channelNo: string;
    isLocked?: boolean;
    favourite?: boolean;
    bottomLabel?: string;
    withFixedWidth?: boolean;
    onClick?: (e: React.SyntheticEvent<Element, Event>) => void;
    ['data-test-id']?: string;
    onClickLock?: () => void;
    responsive?: boolean;
    locked?: boolean;
    channelNumber?: number | string;
    channelTitle?: string;
    category?: string;
    ratio?: number;
}

export const ChannelCard = ({
    isSelected,
    index,
    logoSrc,
    channelNo,
    isLocked,
    favourite,
    bottomLabel,
    onClickLock = () => undefined,
    responsive = false,
    /**
     * If `false`/`undefined` width/height are set to `100%`
     *
     * @todo is this prop used anywhere? - check and remove if not used
     */
    withFixedWidth,
    ratio,
    locked,
    onClick,
    'data-test-id': dataTestId,
}: IChannelCard) => {
    // TODO: add `inView`
    // const { ref, inView } = useInView({ rootMargin: '300px 0px' });
    const showLocked = isLocked ?? locked;
    return (
        <div
            className={styles.wrapper}
            onClick={() => showLocked && onClickLock()}
            id={channelNo}
            data-test-id={dataTestId ?? channelNo}
        >
            <div
                className={cn(styles['channel-card'], {
                    [styles.selected]: isSelected,
                    [styles['fixed-width']]: withFixedWidth,
                    [styles.responsive]: responsive,
                })}
                key={`${index}_channel_card`}
                id={`${index}`}
                onClick={onClick}
            >
                <div className={styles.logo}>
                    <ImageContainer src={logoSrc} ratio={ratio ? ratio : 2.5} />
                </div>
                <div className={styles.topbar}>
                    <span className={styles['channel-number']}>{channelNo}</span>
                    <span className={styles.status}>
                        {favourite && <FontIcon name="heart-filled" size="x-small" md="x-small" color="orange" />}
                        {showLocked && (
                            <FontIcon name="lock" size="x-small" md="smaller" className={styles['lock-icon']} />
                        )}
                    </span>
                </div>
                {bottomLabel && (
                    <Text
                        as="span"
                        truncate
                        title={bottomLabel}
                        size={{ default: '8', md: '10' }}
                        className={styles.label}
                    >
                        {bottomLabel}
                    </Text>
                )}
            </div>
        </div>
    );
};
